module.exports = __webpack_public_path__ + "media/images/products/demo/vrglasses-b1d3019e7e12e325fccb3f32865fb8d8.jpg";